<a href="" (click)="toggle(); false;" class="sg-nav-sub__link py-1 text-right d-md-none">
    {{ (links.showMenu) ? 'Close' : 'More' }} <mlp-ng-icon [name]="(links.showMenu) ? 'arrow-up-1' : 'arrow-down-1'"></mlp-ng-icon>
</a>

<nav class="sg-nav-sub pr-5 py-1 d-none d-md-block">
    <a class="sg-nav-sub__link py-3" [routerLink]="link.url" [routerLinkActive]="'-active'" [routerLinkActiveOptions]="{ exact: links?.routerLinkActiveOptions }" *ngFor="let link of links.mainLinks">
        {{ link.name }}
    </a>
    <a href="" (click)="toggle(); false;" class="sg-nav-sub__link py-3 d-none d-md-inline" *ngIf="links.dropdownLinks">
        {{ (links.showMenu) ? 'Close' : 'More' }} <mlp-ng-icon [name]="(links.showMenu) ? 'arrow-up-1' : 'arrow-down-1'"></mlp-ng-icon>
    </a>
</nav>
